/* Colour maps and the pill builders. Ported verbatim from artifact.html.
   Colour carries meaning here — bucket, stage family, journey phase, metric thresholds —
   so these tables are the single source for it. Flat solid fills only. */

import { esc, scase } from "./util.js";

export const BUCKETS = {
  conversational: ["var(--magenta)", "var(--magenta-soft)"],
  ordinary: ["var(--sub)", "#F1F1F4"],
  pivot: ["var(--violet)", "var(--violet-soft)"],
  uncertain: ["var(--teal)", "var(--teal-soft)"],
  tracker_probe: ["var(--blue)", "var(--blue-soft)"],
  pasted_string: ["var(--amber)", "var(--amber-soft)"],
  long_uncategorised: ["var(--purple)", "var(--purple-soft)"],
};
export const ORDER = Object.keys(BUCKETS);

export const BCOLOR = {
  conversational: "#F50FAF", ordinary: "#C9C9D1", pivot: "#5509F8", uncertain: "#0D9488",
  tracker_probe: "#2563EB", pasted_string: "#D97706", long_uncategorised: "#9333EA",
};

export const STAGE_FAM = (() => {
  const fam = {};
  const set = (names, c, bg) => names.forEach(n => { fam[n] = [c, bg]; });
  set(["Initial Query", "Exploration", "Information Seeking", "Example Request"], "var(--teal)", "var(--teal-soft)");
  set(["Problem Identification", "Solution Seeking", "Troubleshooting", "Diagnosis / Identification", "Cause Investigation"], "var(--red)", "var(--red-soft)");
  set(["Comparison", "Recommendation", "Decision Support", "Alternative Seeking", "Evaluation", "Feedback / Review"], "var(--amber)", "var(--amber-soft)");
  set(["Validation", "Verification", "Clarification", "Challenge / Correction"], "var(--blue)", "var(--blue-soft)");
  set(["Planning", "Generation", "Transformation", "Instruction / Action", "Summarisation", "Synthesis", "How-to / Procedure", "Prompt / Response Control", "Meta Conversation"], "var(--violet)", "var(--violet-soft)");
  set(["Purchase / Transaction", "Post-Purchase"], "var(--green)", "var(--green-soft)");
  set(["Topic Pivot", "Context Reset"], "var(--purple)", "var(--purple-soft)");
  set(["Follow-up", "Refinement", "Specification", "Expansion", "Continuation", "More Options", "Confirmation / Completion", "Ambiguous / Unknown"], "var(--sub)", "#F1F1F4");
  return fam;
})();

export const JPHASE = {
  discovery: ["var(--teal)", "var(--teal-soft)"], education: ["var(--teal)", "var(--teal-soft)"],
  problem: ["var(--amber)", "var(--amber-soft)"], research: ["var(--amber)", "var(--amber-soft)"],
  evaluation: ["var(--amber)", "var(--amber-soft)"], comparison: ["var(--amber)", "var(--amber-soft)"],
  decision: ["var(--green)", "var(--green-soft)"], purchase: ["var(--green)", "var(--green-soft)"],
  post_purchase: ["var(--violet)", "var(--violet-soft)"], troubleshooting: ["var(--violet)", "var(--violet-soft)"],
};

export const TCOLORS = [["var(--violet)", "var(--violet-soft)"]];

/* Opportunity band colours, keyed by the tone the classifier returns. */
export const OPP_TONE = {
  critical: { c: "#fff", bg: "var(--red)" },
  high: { c: "var(--red)", bg: "var(--red-soft)" },
  medium: { c: "var(--amber)", bg: "var(--amber-soft)" },
  moderate: { c: "var(--blue)", bg: "var(--blue-soft)" },
  low: { c: "var(--sub)", bg: "#F1F1F4" },
};

/* Action-card priority colours, keyed by the label the server returns. */
export const PRIORITY_COLORS = {
  Hygiene: ["var(--sub)", "#F1F1F4"],
  High: ["var(--red)", "var(--red-soft)"],
  Medium: ["var(--amber)", "var(--amber-soft)"],
  Low: ["var(--blue)", "var(--blue-soft)"],
};

export const bpill = b => {
  const m = BUCKETS[b] || BUCKETS.ordinary;
  return '<span class="pill" style="color:' + m[0] + ";background:" + m[1] + '">' + scase(b) + "</span>";
};
export const spill = st => {
  if (!st) return "—";
  const m = STAGE_FAM[st] || ["var(--sub)", "#F1F1F4"];
  return '<span class="pill" style="color:' + m[0] + ";background:" + m[1] + ';font-size:10.5px">' + esc(scase(st)) + "</span>";
};
export const jpill = j => {
  if (!j) return "—";
  const m = JPHASE[j] || ["var(--sub)", "#F1F1F4"];
  return '<span class="pill" style="color:' + m[0] + ";background:" + m[1] + ';font-size:10.5px">' + esc(scase(j)) + "</span>";
};
